module.exports = __webpack_public_path__ + "static/media/fan0_lamp1.c90b5d5a.png";